import React, { useContext } from "react";

import Sharing, { SharingProps } from "@/components/Sharing";
import LocaleContext from "@/i18n";

import { Col1, Col2, Col3, FlexGrid, SharingWrap, Text } from "./styles";

export type SharingFooterProps = {
  participants?: number;
} & SharingProps;

const MeterFooter: React.FC<SharingFooterProps> = (
  props: SharingFooterProps
): React.JSX.Element => {
  const localeContext = useContext(LocaleContext);
  const participants = props.participants?.toLocaleString();

  return (
    <FlexGrid data-qa="footer">
      <Col1>
        {participants && (
          <Text>
            <span>{participants}</span>
            {" " + localeContext.translation.participants}
          </Text>
        )}
      </Col1>
      <Col2 />
      <Col3>
        <SharingWrap>
          <Sharing {...props} />
        </SharingWrap>
      </Col3>
    </FlexGrid>
  );
};

export default MeterFooter;
